<template>
  <v-dialog v-if="dialogMode" v-model="messageDialog.value" max-width="360" scrollable persistent>
    <v-card>
      <v-card-title>
        <v-icon :color="color" class="mr-2">{{icon}}</v-icon>{{title}}
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row align="center">
          <v-col cols="12">
            <div v-html="content" v-if="type !='prompt'"></div>
            <div v-else>
              <v-form ref="promptForm">
                <v-text-field dense outlined :label="content" v-model="promptValue" :rules="rules"></v-text-field>
              </v-form>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-if="type!='alert'" color="primary" text @click="onMessageDialogCancel">取消</v-btn>
        <v-btn v-if="type!='alert'" color="primary" @click="onMessageDialogOk">确定</v-btn>
        <v-btn v-if="type=='alert'" color="primary" @click="onMessageDialogOk">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-snackbar v-else v-model="messageDialog.value" absolute transition="slide-y-transition" style="position: fixed;z-index:99991;" :color="color" :timeout="timeout" top centered>
    <div v-html="content||'操作成功'"></div>
    <template v-slot:action>
      <v-icon small @click="messageDialog.value=false">mdi-close</v-icon>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';
import { required } from '../../plugins/rules';

let DefaultOption = {
  info: { color: 'info' },
  error: { color: 'error' },
  warn: { color: 'orange' },
  success: { color: 'success' },
  alert: { title: '提示', content: '操作完成', icon: 'mdi-alert-octagon', color: 'primary' },
  confirm: { title: '请确认', content: '请再次确认是否执行此操作?', icon: 'mdi-cloud-question', color: 'warning' },
  prompt: { title: '请输入', content: '请输入内容', editor: 1, required: true, icon: 'mdi-circle-edit-outline', color: 'primary' }
}
export default {
  data () {
    return {
      promptValue: '',
      dialogTypes: ['alert', 'confirm', 'prompt']
    }
  },
  watch: {
    defaultValue (v) { this.promptValue = v }
  },
  computed: {
    ...mapState({ messageDialog: state => state.messageDialog }),
    type () { return this.messageDialog.type || 'info' },
    dialogMode () { return this.dialogTypes.indexOf(this.type) != -1 },
    title () { return this.messageDialog.title || DefaultOption[this.type].title },
    content () { return this.messageDialog.content || DefaultOption[this.type].content },
    icon () { return this.messageDialog.icon || DefaultOption[this.type].icon },
    color () { return this.messageDialog.color || DefaultOption[this.type].color },
    editor () { return this.messageDialog.editor || DefaultOption[this.type].editor }, // prompt 输入组件类型
    required () { return this.messageDialog.required || DefaultOption[this.type].required }, // prompt 输入是否必填
    rules () { return this.required ? [required()] : [] }, // prompt 输入的验证规则
    defaultValue () { return this.messageDialog.defaultValue },
    timeout () { return this.type == 'error' ? 9000 : 3500 }, // snackbar 自定隐藏的时长
  },
  methods: {
    onMessageDialogCancel () {
      if (this.messageDialog.cancelFn) this.messageDialog.cancelFn();
      this.messageDialog.value = false;
    },
    onMessageDialogOk () {
      if (this.type == 'prompt' && !this.$refs.promptForm.validate()) return;
      if (this.messageDialog.okFn) this.messageDialog.okFn(this.promptValue);
      this.messageDialog.value = false;
    }
  }
}
</script>